const XPT = ({ ...props }) => (
  <svg
    version="1.1"
    {...props}
    viewBox="0 0 1200 1200"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      transform="translate(557)"
      d="m0 0h86l45 6 34 6 30 7 31 9 32 11 24 10 28 13 25 13 27 16 21 14 17 12 18 14 13 11 11 9 17 16 24 24 7 8 9 10 8 10 13 16 13 18 18 27 12 20 12 22 15 30 10 24 9 24 10 30 11 44 7 39 6 48v76l-6 49-8 45-9 35-8 25-10 28-11 26-12 27-12 21-17 29-13 19-12 17-11 14-9 11-11 13-9 10-14 15-14 14-8 7-7 7-11 9-13 11-12 9-19 14-15 10-21 13-21 12-29 15-32 14-29 11-32 10-40 10-33 6-43 6-9 1h-80l-58-8-32-6-36-9-40-13-30-12-24-11-28-14-24-14-19-12-23-16-18-14-11-9-13-11-12-11-13-12-16-16-7-8-12-13-8-10-13-16-13-18-18-27-15-25-10-18-8-16-13-29-10-26-12-36-9-34-8-41-5-37-2-16v-86l7-51 7-37 10-38 12-36 10-26 9-20 11-23 12-22 13-22 12-18 13-19 12-15 7-9 12-14 7-8 9-10 33-33 11-9 15-13 18-14 18-13 23-15 20-12 22-12 26-13 21-9 23-9 36-12 31-8 33-7 32-5z"
      fill="#7D306B"
    />
    <path
      transform="translate(557)"
      d="m0 0h86l45 6 34 6 30 7 31 9 32 11 24 10 28 13 25 13 27 16 21 14 17 12 18 14 13 11 11 9 17 16 24 24 7 8 9 10 8 10 13 16 13 18 18 27 12 20 12 22 15 30 10 24 9 24 10 30 11 44 7 39 6 48v76l-6 49-8 45-9 35-8 25-10 28-11 26-7 16-2-4-4-15-26-84-10-33-10-30-6-11-9-8-12-4-98-1-3-5-14-44-17-56-10-31-6-18-7-12-8-7-8-3-9-1h-91l-3-2-9-28-9-30-27-87-6-14-6-8-8-5-10-3-8-1h-204l-18 2-10 5-7 8-4 8-12 36-9 30-10 31-16 50-3 7-90 1-13 1-10 4-8 8-6 12-11 35-13 43-9 28-12 38-3 7-1 1-98 1-10 3-8 6-6 8-4 8-7 22-14 46-9 28-14 45-4 15-1 8h-2l-13-29-10-26-12-36-9-34-8-41-5-37-2-16v-86l7-51 7-37 10-38 12-36 10-26 9-20 11-23 12-22 13-22 12-18 13-19 12-15 7-9 12-14 7-8 9-10 33-33 11-9 15-13 18-14 18-13 23-15 20-12 22-12 26-13 21-9 23-9 36-12 31-8 33-7 32-5z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(68,877)"
      d="m0 0 11 5 6 1h1031l11-2 4-2-8 16-17 28-12 18-12 17-11 14-9 11-11 13-9 10-14 15-14 14-8 7-7 7-11 9-13 11-12 9-19 14-15 10-21 13-21 12-29 15-32 14-29 11-32 10-40 10-33 6-43 6-9 1h-80l-58-8-32-6-36-9-40-13-30-12-24-11-28-14-24-14-19-12-23-16-18-14-11-9-13-11-12-11-13-12-16-16-7-8-12-13-8-10-13-16-13-18-18-27-15-25-9-16z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(953,706)"
      d="m0 0h103l3 4 9 30 9 28 14 47 9 27v6l-1 1h-300l1-7 7-21 12-39 13-43 10-30 2-2z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(144,706)"
      d="m0 0h82l130 1 3 3 25 82 12 39 5 14-1 4h-300l-1-4 3-7 5-17 24-78 11-35z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(495,351)"
      d="m0 0h212l4 11 20 63 17 54 3 9v5l-178 1-123-1 2-9 7-21 9-30 9-29 11-36 5-15z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(494,707)"
      d="m0 0h213l4 10 13 42 14 46 11 35 2 8-1 1h-301l1-7 9-27 15-49 13-43 5-14z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(756,529)"
      d="m0 0h126l3 8 25 80 13 42 3 10v1l-161 1h-45l-96-1 1-6 9-27 14-45 13-43 7-19z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(318,529)"
      d="m0 0h121l92 1 2 1 14 44 13 42 9 29 7 21v3l-188 1-114-1 1-6 11-33 7-23 21-68z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(927,557)"
      d="m0 0 2 3 22 71 12 38 1 1 98 1 12 4 10 9 8 16 13 41 20 65 14 46 1 11-8 16-8 4-8 1h-922v-1l560-1 1-5 7-2v-1l-13-2-1-1h-9l-3-1v-2l-3-1 2-5 13-2h5v-2l2-1-1-7 3-3 2-9-1-6v-2l-2-1 3-5 8-9 5-5 4 1 3 4 3 2v2l8 1v7l2 1 1 8 1 2 1 5h3l3-3-2 9 58-1h242l-1-9-9-27-15-50-10-32-7-22-1-1h-212v-2l-3-1h2l-1-3h13l15 2v-1l16-2h5l1-2h-2l-1 2-12-4-23-5-4-2 3-1 1-3 10-4h3l-3-3-21-2-11 1-16-1h-14l-27-1-10-1-57-2h-84l-1-1v-5l1 4h141l160-1-16-52v-3h2v2l2-2-2-10v-8l-4-20-1-11h3l4 1 1 3h3v2h2v7l3 1 1 2 3-2 1-10-4-2 1-6 1-3z"
      fill="#422F70"
    />
    <path
      transform="translate(927,557)"
      d="m0 0 2 3 22 71 7 23v11l3 8 4 2v2l12 1 5 1 1 1h9l1 3 3-2 1-1h7v2l-2 1 11 1v1l-8 1-4-1v3l7-1 3 2 7 1 1 4-5 1 2 1v2l-10 1-7-1-6 2-3-1-9 1h-16l-3 1-26 1-11 1-4 1 1 2-41 1h-37v-2l-3-1h2l-1-3h13l15 2v-1l16-2h5l1-2h-2l-1 2-12-4-23-5-4-2 3-1 1-3 10-4h3l-3-3-21-2-11 1-16-1h-14l-27-1-10-1-57-2h-84l-1-1v-5l1 4h141l160-1-16-52v-3h2v2l2-2-2-10v-8l-4-20-1-11h3l4 1 1 3h3v2h2v7l3 1 1 2 3-2 1-10-4-2 1-6 1-3z"
      fill="#52306F"
    />
    <path
      transform="translate(772,810)"
      d="m0 0 4 1 3 4 3 2v2l8 1v7l2 1 1 8 1 2 1 5h3l3-3-2 9h7l3 3h25l7 1h13l6 1 2-1 15 1h10l1 1h7l6 1 10 4v1l-11 2-1 3v4l8 1 1 2h-8v1h-8l-3 2-10 1-37 1h-22l-9 1-5 1-6-1-10 1h-25l-5 1-6-2 2-3 6-1v-1l-13-2-1-1h-9l-3-1v-2l-3-1 2-5 13-2h5v-2l2-1-1-7 3-3 2-9-1-6v-2l-2-1 3-5 8-9z"
      fill="#52306F"
    />
    <path
      transform="translate(744,706)"
      d="m0 0h63l-3 11-14 44-9 30-5 15-2 1-7-23-16-52-8-25z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(452,705)"
      d="m0 0 5 1-3 11-13 42-8 25-7 23-3-3-5-17-22-71-3-10z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(568,529)"
      d="m0 0h63l-2 10-9 28-14 45-4 14-3 1-6-18-21-68z"
      fill="#0FD8D8"
    />
    <path
      transform="translate(454,884)"
      d="m0 0h298l63 2-4 2-10 1-4 1-8 1h-10l-16 1h-56l-32 1-118-1h-161l-26-2v-1l-20-2v-1l56-1h42z"
      fill="#07E3DD"
    />
    <path
      transform="translate(288,503)"
      d="m0 0 3 1-1 5-5 10-11 35-13 43-9 28-6 18h-2l-2 10-3 7h-4v-7l3-8 4-17 6-19 5-15 6-19 4-15 3-7 4-11 2-9 2-5 3-8 2-3 1-5h2l2-5z"
      fill="#07E3DD"
    />
    <path
      transform="translate(466,323)"
      d="m0 0 2 3-4 5-2 5-1 6-11 33-9 30-10 31-12 38-1 2h-2l-1 3-3-1v-6l2-3 2-13 2-7 5-17 3-8 7-21 3-10 8-26 5-14 2-7 4-8 2-5h2l1-4 5-5z"
      fill="#07E3DD"
    />
    <path
      transform="translate(702,351)"
      d="m0 0h5l4 11 17 54v7l-2 2-4-5-2-10-3-5-3-9-2-5-3-8-3-12-2-5-1-5-2-5-9 1-5 1h-42l-5-1-4 1v-2l-6 2h-13l-4-2-1 2h-5v-2l-2 2h-47l-4-1-47-2v-1l191-1z"
      fill="#06E3DD"
    />
    <path
      transform="translate(709,718)"
      d="m0 0 1 3h2l7 22 13 42 6 20 2 11 7 23-2 1 2 4 2 1v2h-21v-2l10-2 3-2-2-13h-2v-6l-3-4-2-9-4-9-3-10-5-15-2-9-3-8-2-7-2-5-2-7-4-16 2-4 2 1z"
      fill="#07E3DD"
    />
    <path
      transform="translate(356,714)"
      d="m0 0 1 2 4 1 23 75v8l-3 1-3-5-2-9-3-5-1-7-3-5-4-14-1-8-3-6-1-7-3-6-3-9v-5z"
      fill="#07E2DC"
    />
    <path
      transform="translate(493,708)"
      d="m0 0h12v1l192 1-4 2-44 1h-36l-6-1-49 1-4 1-18-1-34-1-2 2-6 1z"
      fill="#06E4DD"
    />
    <path
      transform="translate(142,983)"
      d="m0 0 4 1v3l4 2 1 3 4 2v2h2l1 4 4 2 7 6 6 7 6 5 7 8 2 4 3 1 4 6-4-1v-2l-4-2-1-1-2 2-23-23-7-8-12-13-4-6h2z"
      fill="#06E4DD"
    />
    <path
      transform="translate(1146,367)"
      d="m0 0 5 4v2l6 3 9 24 4 11v6l1 4h-2v2l-3-1-4-10-3-9-6-17-4-10 3-2-4-2z"
      fill="#06E3DD"
    />
    <path
      transform="translate(532,541)"
      d="m0 0 5 2 14 45 1 11-2 2-4-7v-4l1-1-1-3-3-1-2-7-3-7-3-11-3-10-2-6v-2z"
      fill="#08E2DC"
    />
    <path
      transform="translate(293,709)"
      d="m0 0h50l9 1-1 2-11 2-7-1-9 1-5-1-6 1h-3-18l-8-1-12 1-16-3v-1z"
      fill="#06E5DE"
    />
    <path
      transform="translate(880,536)"
      d="m0 0 4 2v5l4 4 3 9 2 12 4 12v7h2l3 10-1 3h2l1 6-1 3-2-1-1-5v-3h-2l-2-7v-2-7h-2l-1-4-2-2-3-10-3-6-3-15-3-6z"
      fill="#06E4DD"
    />
    <path
      transform="translate(91,912)"
      d="m0 0 6 5 7 11v2h2l3 5 2 5h2l3 4v2h2l3 5 4 7v2l-7-2-13-18-13-20-2-3z"
      fill="#06E4DD"
    />
    <path
      transform="translate(789,493)"
      d="m0 0h93l9 1v1h-21l-31 1h-43l-7-1z"
      fill="#4A2F70"
    />
    <path
      transform="translate(845,708)"
      d="m0 0h8v1l33 1v1l-28 2h-6l-7 3-2-3 1-4z"
      fill="#06E5DE"
    />
    <path
      transform="translate(552,600)"
      d="m0 0 3 1 5 16v8h-3l-2-2v-7l-4-6-1-7h2z"
      fill="#08E2DC"
    />
    <path
      transform="translate(449,710)"
      d="m0 0h5l-2 9-2 7-1 5-3 3-2-4 1-5 1-2 1-11z"
      fill="#06E4DD"
    />
    <path
      transform="translate(46,831)"
      d="m0 0 6 2 1 5h2l3 4 1 5h2l-2 6-4-1-9-20z"
      fill="#07E3DD"
    />
    <path
      transform="translate(1127,329)"
      d="m0 0h5l3 5 5 4 4 9h-4l-5-1-3-10z"
      fill="#06E4DD"
    />
    <path
      transform="translate(126,963)"
      d="m0 0 4 1 7 8v2h2l1 5-7-2-10-12z"
      fill="#06E4DD"
    />
    <path
      transform="translate(797,703)"
      d="m0 0h12l-1 6-2 5-1-3 2-5h-50v-1l40-1z"
      fill="#492F70"
    />
    <path
      transform="translate(626,530)"
      d="m0 0h4l-1 9h-2l-3 12-2-1-1-5 2-9 2-3h2z"
      fill="#06E3DD"
    />
    <path
      transform="translate(804,707)"
      d="m0 0 1 3-5 15h-3l-1-6 4-9z"
      fill="#06E5DE"
    />
    <path
      transform="translate(909,614)"
      d="m0 0h2l3 12 2 2 2 11 3 7 1 6-2 1-11-36z"
      fill="#432F70"
    />
    <path
      transform="translate(927,557)"
      d="m0 0 2 3 2 8-4 2-4-3 1-6 1-3z"
      fill="#50306F"
    />
    <path
      transform="translate(387,843)"
      d="m0 0h8l2 3-2 1-11 1-5-2 4-2z"
      fill="#06E5DE"
    />
    <path transform="translate(771,792)" d="m0 0 6 2-1 8-4-1z" fill="#07E2DD" />
    <path
      transform="translate(548,589)"
      d="m0 0h2l2 6-1 6-4-4-1-7z"
      fill="#06E5DE"
    />
    <path
      transform="translate(946,622)"
      d="m0 0h2l6 19-1 3h-3l1-4-3-9-2-1 1-3z"
      fill="#422F70"
    />
    <path
      transform="translate(8,498)"
      d="m0 0 2 3 1 2v7l-4 2-1 2z"
      fill="#06E4DD"
    />
    <path
      transform="translate(904,609)"
      d="m0 0 3 3 1 6-2 2v-2h-3l-1-2v-6z"
      fill="#06E5DE"
    />
    <path
      transform="translate(1177,438)"
      d="m0 0 2 3 1 8-4-2-1-3h-2v-2l4-1z"
      fill="#07E3DD"
    />
    <path
      transform="translate(207,1048)"
      d="m0 0 6 5v4l-5-2-3-3z"
      fill="#06E3DD"
    />
    <path
      transform="translate(76,885)"
      d="m0 0 5 1 2 4-3 3-3-2v-2l-2-1h2z"
      fill="#06E5DE"
    />
    <path
      transform="translate(726,427)"
      d="m0 0h4l2 5-1 4-4-2z"
      fill="#06E5DE"
    />
    <path
      transform="translate(410,484)"
      d="m0 0 3 1-1 5-5 2-1-2 3-5z"
      fill="#06E5DE"
    />
    <path
      transform="translate(393,706)"
      d="m0 0 7 1v3l-3 3h-2z"
      fill="#0BDEDB"
    />
    <path
      transform="translate(926,582)"
      d="m0 0 5 3-2 5-3-1-2-6z"
      fill="#7F316B"
    />
    <path
      transform="translate(1181,455)"
      d="m0 0 2 2 1 5-1 2-3-1-2-3 1-4z"
      fill="#06E4DD"
    />
    <path
      transform="translate(923,544)"
      d="m0 0 2 3 2 9-5-1v-3-2h2z"
      fill="#4D3070"
    />
    <path
      transform="translate(384,805)"
      d="m0 0 3 1 1 7-4-1-1-5z"
      fill="#06E5DE"
    />
    <path
      transform="translate(495,352)"
      d="m0 0h8l-2 4-5 1-2-1z"
      fill="#06E5DE"
    />
    <path
      transform="translate(955,647)"
      d="m0 0 2 4 1 5-5 2v-4l1-3 1 1z"
      fill="#422F70"
    />
  </svg>
);
export default XPT;
